export function highlightGeoNames(
  text: string,
  names: { name: string; placeId: string }[]
): string {
  if (names.length === 0) return escapeHtml(text)

  const sorted = [...names].sort((a, b) => b.name.length - a.name.length)
  let result = ''
  let i = 0

  while (i < text.length) {
    let matched = false
    for (const { name, placeId } of sorted) {
      if (text.startsWith(name, i)) {
        result += `<span class="geo-highlight" data-place-id="${placeId}">${escapeHtml(
          name
        )}</span>`
        i += name.length
        matched = true
        break
      }
    }
    if (!matched) {
      result += escapeHtml(text[i])
      i++
    }
  }

  return result
}

function escapeHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}
